var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"d-flex flex-column align-center justify-center",attrs:{"height":"300","width":"100%"}},[_c('div',{staticClass:"text-h3 font-weight-black blue--text text--darken-2"},[_vm._v("404")]),_c('div',{staticClass:"text-h4 font-weight-black error--text mt-5"},[_vm._v(" Sorry, "+_vm._s(_vm.name)+" not found ! ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }